module.exports = {
    text: 'Produzido por <a href="http://www.sapo.pt/" rel="nofollow">SAPO</a> - Todos os direitos reservados.',
    lang: {
        'tet_TL': 'Produsaun hosi <a href="http://www.sapo.pt/" rel="nofollow">SAPO</a> - Ho direitu hotu-hotu rezervadu.',
        'en_US': 'Produced by <a href="http://www.sapo.pt/" rel="nofollow">SAPO</a> - All rights reserved.'
    }
}